export const emojiUrl = 'https://imgcache.qq.com/open/qcloud/tim/assets/emoji/'
export const emojiMap = {
  '[OK]': 'emoji_1@2x.png',
  '[么么哒]': 'emoji_3@2x.png',
  '[可爱]': 'emoji_18@2x.png',
  '[太阳]': 'emoji_34@2x.png',
  '[强]': 'emoji_45@2x.png',
  '[彩带]': 'emoji_46@2x.png',
  '[彩球]': 'emoji_47@2x.png',
  '[微笑]': 'emoji_49@2x.png',
  '[憨笑]': 'emoji_56@2x.png',
  '[抱拳]': 'emoji_63@2x.png',
  '[握手]': 'emoji_66@2x.png',
  '[棒棒糖]': 'emoji_72@2x.png',
  '[爱你]': 'emoji_82@2x.png',
  '[爱心]': 'emoji_83@2x.png',
  '[玫瑰]': 'emoji_88@2x.png',
  '[示爱]': 'emoji_95@2x.png',
  '[礼品袋]': 'emoji_96@2x.png',
  '[礼物]': 'emoji_97@2x.png',
  '[蛋糕]': 'emoji_108@2x.png',
  '[鼓掌]': 'emoji_140@2x.png',
}
export const emojiName = [
  '[强]',
  '[玫瑰]',
  '[爱心]',
  '[抱拳]',
  '[OK]',
  '[太阳]',
  '[鼓掌]',
  '[礼物]',
  '[可爱]',
  '[么么哒]',
  '[憨笑]',
  '[握手]',
  '[蛋糕]',
  '[爱你]',
  '[彩带]',
  '[棒棒糖]',
]
